import React, {useEffect, useRef, useState} from 'react'
import styles from './TimeClockPage.module.css'
import {
    Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, FormControlLabel,
} from '@material-ui/core'
import axios from "axios";
import LoadingBackdrop from "../../../../components/common/LoadingBackdrop";
import {
    Alert, AlertColor,
    Container,
    FormControl,
    FormHelperText,
    FormLabel,
    Grid, ImageList, ImageListItem, ImageListItemBar,
    InputLabel, MenuItem, Paper,
    Radio,
    RadioGroup,
    Select
} from "@mui/material";
import Box from "@mui/material/Box";
import {DataListObject, FieldListObject, FieldListValues} from "../../../../queries/useDispatch";
import IconButton from "@mui/material/IconButton";
import {Add, Delete, Edit} from "@mui/icons-material";
import dayjs from "dayjs";
import DeleteIcon from "@mui/icons-material/Delete";
import {Controller, useForm} from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import NumberFormat from "react-number-format";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {MobileDateTimePicker} from "@mui/x-date-pickers/MobileDateTimePicker";
import Typography from "@mui/material/Typography";
import Compressor from "compressorjs";
import {Wrapper} from "@googlemaps/react-wrapper";
import Dropzone from "react-dropzone";
import SignatureCanvas from 'react-signature-canvas'
import { v4 as uuid } from "uuid";
import {getConfig} from "../../../../AppConfig";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import HookForm from "../../../../components/common/HookForm";
import Snackbar from "@mui/material/Snackbar";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {GridCellParams, GridColDef} from "@mui/x-data-grid-pro";

const MapComponent: React.FC<{
    center: { lat: number; lng: number }
    zoom: number
}> = ({ center, zoom }) => {
    const mapRef = useRef<HTMLDivElement>()
    const mapInstanceRef = useRef<any>(null)

    useEffect(() => {
        if (mapInstanceRef.current) return // already initialized, don't recreate

        // @ts-ignore
        mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
            center,
            zoom
        })

        // @ts-ignore
        const marker = new window.google.maps.Marker({
            position: center,
            map: mapInstanceRef.current
        })

        marker.addListener("click", () => {
            window.open("https://maps.google.com?q=" + center.lat + "," + center.lng)
        })
    }, []) // empty deps - only run once on mount

    return (
        <div
            ref={mapRef}
            style={{ backgroundColor: 'lightblue', width: '100%', height: '300px' }}
        />
    )
}
const TimeClockPage = (params) => {
    const formMethods = useForm({
        mode: 'onBlur',
        reValidateMode: "onChange",
        // shouldUnregister: false
    })
    const {resetField, control, formState: { isDirty, dirtyFields, submitCount, errors }} = formMethods
    const { mapapikey } = getConfig()
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [lookupData, setLookupData] = React.useState([])
    const [expandedState, setExpandedState] = React.useState([])
    const [photoUploadMessageCount, setPhotoUploadMessageCount] = React.useState([])
    const lockedValues = JSON.parse(localStorage.getItem(params.userGuid))
    const [signatureLocked, setSignatureLocked] = React.useState<{controlName: string, value: boolean}[]>(lockedValues ? lockedValues : [])
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [groupPhotos, setGroupPhotos] = React.useState([])
    const [errorSections, setErrorSections] = useState([])
    const [radioValues, setRadioValues] = React.useState<{controlName: string, value: string, showgroup: string, showgroupvalue: boolean}[]>([])
    const [signatureRefsData, setSignatureRefsData] = React.useState([])
    const [snackbarOpen, setSnackbarOpen] = React.useState<{ open: boolean, message: string, type: AlertColor }>({ open: false, message: '', type: 'success' })
    const [timeEntryGridSetting, setTimeEntryGridSettings] = React.useState({timeentrylist: [], fieldlist: []})
    const [timeEntryGridColumns, setTimeEntryGridColumns] = React.useState<GridColDef[]>([])
    const [timeentryid, settimeentryid] = React.useState(null)
    const [dialogMsg, setDialogMsg] = React.useState("")
    const [dialogObj, setDialogObj] = React.useState({ msg: '', id: 0 })

    const [timeEntryData, setTimeEntryData] = React.useState(
        {
            title: '',
            employeename: '',
            sections: [],
            isreadonly: false,
        })

    const labelRegex = /<(.*?)>/g

    useEffect(() => {
        params.setTitle('Time Entry')
        setLoadingBackdrop(true)
        getLookupData()
        getGridSettings()
        getTimeEntryData(null)
    }, [])

    useEffect(() => {
        if (params.setDisplayTimeEntry) {
            params.setBackArrow('timeentry')
        }
    }, [params.backArrowClick])

    useEffect(() => {
        if (signatureLocked && signatureLocked?.length > 0) {
            localStorage.setItem(params.userGuid, JSON.stringify(signatureLocked));
        }
    }, [signatureLocked])

    useEffect(() => {
        timeEntryData?.sections?.map((section, i) => {
            section?.flist?.map((flistflist) => {
                const controlId = section.sectionid.toString() + "--" + flistflist.id.toString() + "--" + flistflist.ctrl.toString()
                // resetField(controlId, { keepError: false, keepTouched: false, defaultValue: undefined })
                const controlValueId = 'v' + flistflist.ctrl
                var value = flistflist[controlValueId]
                if (flistflist.ctrl == 1) {
                    if (typeof value === 'boolean' ) {
                        value = flistflist[controlValueId] == true ? '1' : '0'
                    }
                    else {
                        value = ''
                    }
                    setRadioValues(prevValues => {
                        return [...prevValues.filter(item => (item.controlName != controlId)), {controlName: controlId, value: value, showgroup: flistflist.showgroup, showgroupvalue: flistflist.showgroupvalue}]
                    })
                    resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: value})
                    // setValue(controlId, flistflist[controlValueId] == true ? '1' : '0')
                }
                else if (flistflist.ctrl == 2) {
                    if (value) {
                        var lookupOption = null
                        lookupOption = lookupData.find((item) => item.lookupid === Number(flistflist[controlValueId]))

                        if (lookupOption) {
                            const newOption = { value: lookupOption.lookupid, label: lookupOption.lookup }
                            // setValue(controlId, newOption)
                            resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: newOption })
                        }
                        else {
                            resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: null })
                        }
                    }
                    else {
                        resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: null })
                    }
                }
                else if (flistflist.ctrl == 5) {
                    if (!value) {
                        value = ''
                    }
                    resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: value})
                }
                else if (flistflist.ctrl == 7) {
                    var values = value
                    if (typeof value === 'string' && value.length > 0) {
                        values = value.split(',')
                    }
                    else {
                        values = []
                    }

                    // setValue(controlId, values)
                    resetField(controlId, { keepError: true, keepTouched: true, defaultValue: values })
                }
                else if (flistflist.ctrl == 8) {
                    if (!value) {
                        value = ''
                    }
                    resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: value})
                }
                else if (flistflist.ctrl == 9) {
                    if (!value) {
                        value = ''
                    }
                    resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: value})
                }
                else if (flistflist.ctrl == 10) {
                    const base64Data = value
                    const objSig = getCreateSignatureObject(controlId, base64Data)
                    if (objSig?.ref && base64Data && base64Data?.length > 0) {
                        if (objSig?.ref?.current) {
                            const preloadedSignature = "data:image/png;base64," + base64Data
                            objSig.ref.current.fromDataURL(preloadedSignature);
                        }

                        setSignatureLocked(prevState => {
                            const foundRef = prevState.filter(ref => ref.controlName != controlId)
                            return [...foundRef, {controlName: controlId, value: true}]
                        })
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: base64Data })
                    }
                    else if (objSig?.ref?.current) {
                        setSignatureLocked(prevState => {
                            return []
                        })
                        clearSignaturePad(controlId)
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: '' })
                    }
                    else {
                        setSignatureLocked(prevState => {
                            return []
                        })
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: '' })
                    }
                }
                else {
                    const controlValueId = 'v' + flistflist.ctrl
                    if (value) {
                        resetField(controlId, { keepError: false, keepDirty: false, keepTouched: true, defaultValue: flistflist[controlValueId] })
                    }
                    else {
                        resetField(controlId, { keepError: false, keepDirty: false, keepTouched: true, defaultValue: undefined })
                    }

                    // setValue(controlId, flistflist[controlValueId])
                }
            })
        })
    }, [timeEntryData])

    const startFileProcessing = async (imgFile: any, lbl) => {
        try {
            if (!imgFile?.name) throw new Error('Please select a valid image file.');

            var watermarkLabel = lbl

            // if (labelRegex.test(watermarkLabel)) {
            //     if (dlistItem?.flist && dlistItem?.flist?.length > 0) {
            //         dlistItem?.flist?.forEach((value) => {
            //             const keys = Object.keys(value);
            //             if (keys && keys?.length > 1) {
            //                 watermarkLabel = watermarkLabel.replace('<' + value.id + '>', value[keys[1]])
            //             }
            //         })
            //     }
            // }
            if (labelRegex.test(watermarkLabel)) {
                timeEntryData?.sections?.map(section => {
                    if (!section?.multiple) {
                        section.dlist?.map((dlistItem, index: number) => {
                            if (dlistItem?.flist && dlistItem?.flist?.length > 0) {
                                dlistItem?.flist?.forEach((value) => {
                                    const keys = Object.keys(value);
                                    if (keys && keys?.length > 1) {
                                        watermarkLabel = watermarkLabel.replace('<' + value.id + '>', value[keys[1]])
                                    }
                                })
                            }
                        })
                    }
                })
            }

            watermarkLabel = watermarkLabel.replace('<DATETIME>', dayjs().format('MM/DD/YYYY hh:mmA'))

            const textWatermarkFile = await textWatermark(imgFile, watermarkLabel);

            return textWatermarkFile;
        } catch (error) {
            console.log(`${error}`);
        } finally {
        }
    }

    const textWatermark = async (imgOriginal: File, watermarkText: string, quality = 0.4) : Promise<Blob> => {
        return new Promise((resolve, reject) => {
            let canvas: any = document.createElement('canvas');
            canvas.imageSmoothingQuality = 'medium';

            let context: any = canvas.getContext('2d');

            let img = document.createElement('img');
            img.src = URL.createObjectURL(imgOriginal);

            img.onload = async () => {
                canvas.width = img.width;
                canvas.height = img.height;

                // Draw the original image
                context.drawImage(img, 0, 0, canvas.width, canvas.height);

                // === Watermark settings ===
                const sidePadding = 40;
                const verticalPadding = 30; // extra space above/below text
                const fontSize = Math.max(Math.floor(canvas.width * 0.03), 28); // scale with image width
                const lineHeight = fontSize * 1.4;
                const maxTextWidth = canvas.width - sidePadding * 2;

                context.font = `bold ${fontSize}px Arial`;
                context.textAlign = "center";
                context.textBaseline = "bottom";

                // Wrap watermark text based on canvas width
                const lines = wrapText(context, watermarkText, maxTextWidth);

                // Compute background height dynamically based on number of lines
                const bgHeight = lines.length * lineHeight + verticalPadding * 2;
                const bgY = canvas.height - bgHeight;

                // Draw semi-transparent background rectangle
                context.fillStyle = 'rgba(14,13,13,0.65)';
                context.fillRect(0, bgY, canvas.width, bgHeight);

                // Draw watermark text (centered horizontally)
                context.fillStyle = 'rgba(255,255,255,0.75)';
                const startY = bgY + verticalPadding + fontSize;
                lines.forEach((line, i) => {
                    context.fillText(line, canvas.width / 2, startY + i * lineHeight);
                });

                return context.canvas.toBlob((blob: any) => resolve(blob), 'image/jpeg', quality);
            };

            img.onerror = () => reject(`${imgOriginal.name} is invalid image format.`);
        });
    };

    function wrapText(context: any, text: string, maxWidth: number): string[] {
        const words = text.split(' ');
        const lines: string[] = [];
        let currentLine = words[0];

        for (let i = 1; i < words.length; i++) {
            const word = words[i];
            const width = context.measureText(currentLine + " " + word).width;
            if (width < maxWidth) {
                currentLine += " " + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        }
        lines.push(currentLine);
        return lines;
    }

    const getLookupData = () => {
        axios.get(`fieldsystemtimeentrylookups`).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            setLookupData(parsedResponse.lookuplist)
            setLoadingBackdrop(false)
        })
    }

    const handleEdit = (params: GridCellParams) => {
        settimeentryid(prevState=> {
            return params?.row?.timeentryid
        })
        setSignatureRefsData(prevState => { return [] })
        getTimeEntryData(params?.row?.timeentryid)
    }

    const handleDelete = (params: GridCellParams) => {
        setDialogObj({
            msg: 'Are you sure you want to delete time entry for \"' + params.row.employeename + "\"?",
            id: params.row.timeentryid
        })
    }

    const editColumnDef = {
        field: 'Edit',
        width: 50,
        align: "center",
        headerAlign: "center",
        disableColumnMenu: true,
        sortable: false,
        renderCell: (params) => (
            <>
                {!params.row.readonly &&
                    <IconButton className={styles.button} onClick={() => { handleEdit(params) }}>
                        <Edit />
                    </IconButton>
                }
            </>
        )
    }

    const deleteColumnDef = {
        field: 'action',
        headerName: '',
        width: 50,
        sortable: false,
        align: "center",
        headerAlign: "center",
        disableColumnMenu: true,
        renderCell: (params) => (
            <>
                {!params.row.readonly &&
                    <IconButton className={styles.button} onClick={() => { handleDelete(params) }}>
                        <Delete />
                    </IconButton>
                }
            </>
        )
    }

    const getFieldFormatted = (value) => {
        if (typeof value == "boolean") {
            return value == true ? 'Yes' : 'No'
        }
        else {
            return value
        }
    }

    const getGridSettings = () => {
        setLoadingBackdrop(true)
        axios.get(`fieldsystemtimeentry`).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            const newTimeEntryList = parsedResponse?.timeentrylist.map(tel => {
                return {...tel, id: tel.timeentryid}
            })
            const newTimeColumns = parsedResponse?.fieldlist?.map(fl => {
                return {
                    field: fl.schedulefield,
                    type: 'string', // use schedulefieldcontrol which  is  a number of control type
                    headerName: fl.schedulefieldlabel,
                    width: fl.width,
                    align: fl.align,
                    headerAlign: fl.headeralign,
                    valueFormatter: (value: any, row, column, apiRef) => {
                        return getFieldFormatted(value.value)
                    }
                }
            })

            setTimeEntryGridColumns(prevState => {
                return [editColumnDef, ...newTimeColumns, deleteColumnDef]
            })
            setTimeEntryGridSettings({...parsedResponse, timeentrylist: newTimeEntryList})
        })
    }

    const getTimeEntryData = (timeentryid) => {
        setLoadingBackdrop(true)
        var body = {}
        if (timeentryid) {
            body['timeentryid'] = timeentryid
        }
        axios.post(`fieldsystemtimeentry`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            if (parsedResponse?.status === "failure") {
                getGridSettings()
                setDialogMsg(parsedResponse?.message)
            }
            else {
                if (parsedResponse?.employee) {
                    params.setSubTitle(parsedResponse?.company + ' - ' + parsedResponse?.employee)
                }

                setTimeEntryData(parsedResponse)

                if (timeentryid && parsedResponse?.sections && parsedResponse?.sections?.length > 0) {
                    const isFoundObj = expandedState.find(expItem => expItem.sectionid == parsedResponse?.sections[0].sectionid)
                    if (isFoundObj) {
                        isFoundObj.expanded = true
                    }
                    else {
                        const tempExpandedState = [...expandedState]
                        setExpandedState([...tempExpandedState, {sectionid: parsedResponse?.sections[0].sectionid, expanded: true}])
                    }
                }
                setLoadingBackdrop(false)
            }
        })
    }

    const resetForm = () => {
        if (timeentryid) {
            settimeentryid(null)
            getTimeEntryData(null)
        }
        else {
            getTimeEntryData(null)
        }
    }

    const resetAndKeepForm = (data) => {

        timeEntryData?.sections?.map((section, i) => {
            section?.flist?.map((flistflist) => {
                const controlId = section.sectionid.toString() + "--" + flistflist.id.toString() + "--" + flistflist.ctrl.toString()
                const controlValueId = 'v' + flistflist.ctrl
                var value = flistflist[controlValueId]
                if (flistflist.ctrl == 1) {
                    if (flistflist.keepvalue) {
                        setRadioValues(prevValues => {
                            return [...prevValues.filter(item => (item.controlName != controlId)), {controlName: controlId, value: data[controlId], showgroup: flistflist.showgroup, showgroupvalue: flistflist.showgroupvalue}]
                        })
                    }
                    else {
                        if (typeof value === 'boolean' ) {
                            value = flistflist[controlValueId] == true ? '1' : '0'
                        }
                        else {
                            value = ''
                        }
                        setRadioValues(prevValues => {
                            return [...prevValues.filter(item => (item.controlName != controlId)), {controlName: controlId, value: value, showgroup: flistflist.showgroup, showgroupvalue: flistflist.showgroupvalue}]
                        })
                    }
                }
                else if (flistflist.ctrl == 2) {
                    debugger
                    if (flistflist.keepvalue) {
                        debugger
                        resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: data[controlId] })
                    }
                    else {
                        if (value) {
                            var lookupOption = null
                            lookupOption = lookupData.find((item) => item.lookupid === Number(flistflist[controlValueId]))

                            if (lookupOption) {
                                const newOption = { value: lookupOption.lookupid, label: lookupOption.lookup }
                                // setValue(controlId, newOption)
                                resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: newOption })
                            }
                            else {
                                resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: null })
                            }
                        }
                        else {
                            resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: null })
                        }
                    }
                }
                else if (flistflist.ctrl == 7) {
                    if (flistflist.keepvalue) {
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: data[controlId] })
                    }
                    else {
                        var values = value
                        if (typeof value === 'string' && value.length > 0) {
                            values = value.split(',')
                        }
                        else {
                            values = []
                        }
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: values })
                    }
                }
                else if (flistflist.ctrl == 8) {
                    if (flistflist.keepvalue) {
                        resetField(controlId, {
                            keepError: false,
                            keepDirty: true,
                            keepTouched: true,
                            defaultValue: data[controlId]
                        })
                    }
                    else {
                        if (!value) {
                            value = ''
                        }
                        resetField(controlId, {
                            keepError: false,
                            keepDirty: true,
                            keepTouched: true,
                            defaultValue: value
                        })
                    }
                }
                else if (flistflist.ctrl == 9) {
                    if (flistflist.keepvalue) {
                        resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: data[controlId]})
                    }
                    else {
                        if (!value) {
                            value = ''
                        }
                        resetField(controlId, { keepError: false, keepDirty: true, keepTouched: true, defaultValue: value})
                    }
                }
                else if (flistflist.ctrl == 10) {
                    if (!flistflist.keepvalue) {
                        clearSignaturePad(controlId)
                        resetField(controlId, { keepError: true, keepTouched: true, defaultValue: '' })
                    }
                }
                else {
                    if (flistflist.keepvalue) {
                        resetField(controlId, { keepError: false, keepDirty: false, keepTouched: true, defaultValue:  data[controlId] })
                    }
                    else {
                        resetField(controlId, { keepError: false, keepDirty: false, keepTouched: true, defaultValue: undefined })
                    }
                }
            })
        })
    }

    const submitForm = async (data: FormData) => {
        setLoadingBackdrop(true)

        const dataKeys = Object.keys(data)
        var dataStructure = {
            guid: params.userGuid
        }

        if (timeentryid) {
            dataStructure['timeentryid'] = timeentryid
        }

        const copyItems = [];
        dataKeys.forEach(key => {
            var idsArray = key.split("--")
            const ctrl = Number(idsArray[2])
            const controlValueNumber = 'v' + ctrl
            var tempObject = {id: idsArray[1]}
            if (data[key]) {
                var dataToSave = data[key]
                if (ctrl == 1) {
                    dataToSave = dataToSave === '1'
                }
                else if (ctrl == 2) {
                    dataToSave = dataToSave.value
                }
                else if (ctrl === 6) {
                    if (dataToSave) {
                        dataToSave = dayjs(dataToSave, "YYYY-MM-DD")
                    }
                }
                else if (ctrl == 7) {
                    const newItemValueTest = dataToSave.join(',')
                    dataToSave = newItemValueTest
                }
                tempObject[controlValueNumber] = dataToSave
                copyItems.push(tempObject)
            }
        })
        dataStructure['controlvalues'] = copyItems
        axios.put(`fieldsystemtimeentry`, dataStructure).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            if (dataJson.status === 'success') {
                if (timeentryid) {
                    settimeentryid(null)
                    getTimeEntryData(null)
                }
                else {
                    settimeentryid(null)
                    resetAndKeepForm(data)
                }

                setSnackbarOpen( { open: true, message: dataJson.message, type: 'success' })
                getGridSettings()
            }
            else if (dataJson.status === 'invalid') {
                setSnackbarOpen( { open: true, message: dataJson.message, type: 'error' })
                // setDialogMsg(dataJson.message)
            }
            else if (dataJson.status === 'failure') {
                // setDialogMsg(dataJson.message)
                setSnackbarOpen( { open: true, message: dataJson.message, type: 'error' })
            }
            setLoadingBackdrop(false)
        })
    }

    const getExpandedDefault = (expandEnum) => {
        // "expand":1 --Allow Expand/Collapse (start off collapsed) DEFAULT
        // "expand":2 --Allow Expand/Collapse (start off expanded)
        // "expand":3 --DON'T Allow Expand/Collapse (expanded ALWAYS)

        if (expandEnum === 1) {
            return false
        }
        else if (expandEnum === 2) {
            return true
        }
        else if (expandEnum === 3) {
            return true
        }
        else {
            return false
        }
    }


    const getMap = (mapValue: string) => {
        const center = mapValue.split(',').reduce(
            (acc: any, value, i) => {
                if (i === 0) {
                    acc.lat = Number(value)
                } else {
                    acc.lng = Number(value)
                }
                return acc
            },
            { lat: 0, lng: 0 }
        )


        return  (center && center.lat > 0 ? (
                    <Grid item height={'100%'} width={'100%'}>
                        <Wrapper apiKey={mapapikey}>
                            <MapComponent center={center} zoom={10} />
                        </Wrapper>
                    </Grid>
                )
                :
                ( <></> )
        )
    }

    function dataURLtoFile(dataurl: string, filename: string) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const getOptionsForGroupSelectNew = (keyValue, sectionid, schedulefieldheaderid) => {
        if (lookupData) {
            const lookupOptions = lookupData.filter((item) => (item.lookupheaderid === Number(schedulefieldheaderid) && item.lookupactive === true))
            if (lookupOptions && lookupOptions?.length > 0) {
                const arrayOfLookups = lookupOptions?.map(item => (
                    <MenuItem key={item.uniqueid} value={item.lookupid}>
                        {item.lookup}
                    </MenuItem>
                ))

                return arrayOfLookups
            }
            else {
                return [(<MenuItem key={1} value={1}>
                    {''}
                </MenuItem>)]
            }
        }
        else {
            return [(<MenuItem key={1} value={1}>
                {''}
            </MenuItem>)]
        }
    }

    const getDynamicGroupPhotosSection =  (sectionid, fieldid, lbl) => {
        return (
            <>
                <ImageList
                    // sx={{ width: 300, height: 250, alignItems: 'center', overflow: 'auto', }}  cols={1} gap={8} rowHeight={200} style={{alignItems: 'center'}}
                    sx={{
                        // width: 300,
                        // height: 250,
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        // Promote the list into its own layer in Chrome. This costs memory, but helps keeping high FPS.
                        transform: 'translateZ(0)',
                        width: '100%'
                    }}
                    rowHeight={200}
                    gap={1}
                >
                    {timeEntryData?.isreadonly != true &&
                        <ImageListItem key={'newImage'} style={{height:200, width:200, objectFit: 'none', border: '2px solid gray'}}>
                            <Dropzone onDrop={(files: File[]) => {onDropGroupPhoto(files, sectionid, fieldid, lbl)}}>
                                {({
                                      getRootProps,
                                      getInputProps,

                                      isDragActive,
                                      isDragAccept,
                                      isDragReject,
                                      acceptedFiles,
                                      fileRejections,
                                  }) => (
                                    // <div style={{height:200, width:200}} {...getRootProps()} className={styles.dropzone}>
                                    <Paper style={{height:200, width:200}} {...getRootProps()} elevation={2} >Drag and Drop image(s) here, or click to select files
                                        <input {...getInputProps()} />
                                    </Paper>
                                    // </div>
                                )}
                            </Dropzone>
                        </ImageListItem>
                    }
                    {groupPhotos?.filter(photo=> photo.fieldid == fieldid && photo.delete == false)?.map((item) => (
                        <ImageListItem key={item.id} sx={{height:200, width:200, objectFit: 'none', border: '2px solid gray'}}>
                            {item.photo == null &&
                                <Box
                                    className={styles.box}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    height={"100%"}
                                    width={"100%"}
                                >
                                    <CircularProgress />
                                </Box>
                            }

                            {item.photo != null &&
                                <>
                                    <ImageListItemBar
                                        key={item.id + '-delete'}
                                        sx={{
                                            background:
                                                'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                                'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)'
                                        }}
                                        title={item.name}
                                        position="top"
                                        actionIcon={
                                            <>
                                                {timeEntryData?.isreadonly != true &&
                                                    <IconButton sx={{color: 'white'}} aria-label={`star ${item.name}`}>
                                                        <DeleteIcon onClick={(e) => {deleteGroupPhoto(sectionid, item)}}/>
                                                    </IconButton>
                                                }
                                            </>
                                        }
                                        actionPosition="left"
                                    />
                                    <img
                                        srcSet={`data:image/png;base64,${item.photo}`}
                                        src={`data:image/png;base64,${item.photo}`}
                                        // srcSet={`data:image/png;base64,${item.imageData}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                        // src={`data:image/png;base64,${item.imageData}?w=164&h=164&fit=crop&auto=format`}
                                        alt={item.name}
                                        loading="eager"
                                        style={{maxHeight:200, maxWidth:200, objectFit: 'contain'}}
                                    />
                                </>
                            }


                        </ImageListItem>
                    ))}
                </ImageList>
            </>
        )
    }

    const onDropGroupPhoto = async (files: File[], sectionid, fieldid, lbl) => {
        const fileNames = files.map(tempFile => {
            return {'name': tempFile.name}
        })
        setPhotoUploadMessageCount(prevState => {
            return [...fileNames]
        })
        for (const fileToUpload of files) {

            const watermarkedImage = await startFileProcessing(fileToUpload, lbl)

            // var compressedFile;
            const fileReader = new FileReader()

            fileReader.onloadend = async function (event) {
                const data = event.target.result as string
                const unique_id = uuid();
                // Get first 8 characters using slice
                const id = unique_id.slice(0, 8)
                const myImageData = data.split(';base64,')[1]

                setLoadingBackdrop(false)
                const newPhotos = {
                    id: id,
                    photo: myImageData,
                    // imageDataBlob: compressedFileString,
                    filename: fileToUpload.name,
                    size: fileToUpload.size,
                    // size: myImageData.length,
                    type: fileToUpload.type,
                    fieldid: fieldid,
                    // dlistid2: dlistid2,
                    guid: params.userGuid,
                    sectionid: sectionid,
                    docid: null,
                    delete: false,
                    inprocess: false,
                }

                setGroupPhotos(prevState => [...prevState, newPhotos])
            }

            fileReader.readAsDataURL(watermarkedImage)
        }
    }

    const deleteGroupPhoto = (sectionid, photoObject) => {
        const tempGroupPhoto = groupPhotos?.find(photo => (photo.id == photoObject.id))
        tempGroupPhoto['delete'] = true
        setGroupPhotos(prevState => {
            return [...groupPhotos]
        })
    }
    const clearSignaturePad = (controlName) => {
        setSignatureRefsData(prevState => {
            const currentSig = prevState.find(ref => ref.key == controlName)
            if (currentSig && currentSig?.ref && currentSig?.ref?.current) {
                currentSig.ref.current.clear()
                currentSig.base64Data = ""
                const allSigs = prevState.filter(ref => ref.key != controlName)
                return [...allSigs, currentSig]
            }
        })
    }

    const lockUnlockSignaturePad = (controlName, value) => {
        setSignatureLocked(prevState => {
            const foundRef = prevState.filter(ref => ref.controlName != controlName)
            return [...foundRef, {controlName: controlName, value: value}]
        })
    }

    const getCreateSignatureObject = (controlName: string, base64Data?: string) => {
        const currentSig = signatureRefsData.find(ref => ref.key == controlName)
        var newSignatures = []
        var sigObj = currentSig
        if (currentSig && currentSig?.ref && currentSig?.ref?.current) {
            currentSig.ref.current.clear()
            currentSig.base64Data = base64Data
            sigObj = currentSig
            const allSigs = signatureRefsData.filter(ref => ref.key != controlName)
            newSignatures = [...allSigs, currentSig]
        }
        else {
            const sigRef = React.createRef() as React.MutableRefObject<any>
            sigObj = {key: controlName, ref: sigRef, base64Data: base64Data}
            newSignatures = [signatureRefsData, sigObj]
        }
        setSignatureRefsData(newSignatures)

        return sigObj
    }

    const getSignatureObject = (controlName: string) => {
        const foundObject = signatureRefsData?.find(ref => ref.key == controlName)
        if (foundObject) {
            return foundObject
        }
        else {
            return null
        }
    }

    const getNewSignatureRef = (controlName) => {
        const currentSigObj = getSignatureObject(controlName)
        if (currentSigObj && currentSigObj?.ref) {
            return currentSigObj.ref
        }
        else {
            const sigRef = React.createRef() as React.MutableRefObject<any>
            const sigObj = {key: controlName, ref: sigRef, base64Data: null}
            setSignatureRefsData(prevState => {
                return [...prevState, sigObj]
            })
            return sigRef
        }
    }

    const getSignatureRef = (controlName) => {
        const foundRef = signatureRefsData.find(ref => ref.key == controlName)
        if (foundRef) {
            return foundRef.ref
        }
        else {
            return null
        }
    }

    const setSignatureImageData = (controlName, controlData, base64Data) => {
        // const foundRef = signatureRefsData.find(ref => ref.key === controlName)
        // debugger
        // if (foundRef) {
        //     console.log(base64Data)
        //     foundRef.base64Data = base64Data
        //     resetField(controlName, { keepError: false, keepTouched: true, defaultValue: base64Data })
        // }

        setSignatureRefsData(prevState => {
            const currentSig = prevState.find(ref => ref.key == controlName)
            if (currentSig) {
                currentSig.base64Data = base64Data
                const allSigs = prevState.filter(ref => ref.key != controlName)
                return [...allSigs, currentSig]
            }
            else {
                const sigRef = React.createRef() as React.MutableRefObject<any>
                const sigObj = {key: controlName, ref: sigRef, base64Data: base64Data}
                return [...prevState, sigObj]
            }
        })
        resetField(controlName, { keepError: false, keepTouched: true, defaultValue: base64Data })
    }

    const getOptions = (dynamiclookuplist, optionTOLookup) => {
        if (dynamiclookuplist) {
            const lookupOptions = dynamiclookuplist.filter((item) => item.lookupheaderid === Number(optionTOLookup))

            return lookupOptions.map(options => (
                {label: options.lookup, value: options.lookupid}
            ))
        }
    }

    const handleRadioChange = (event, controlName, showgroup, showgroupvalue) => {
        const { value } = event.target;

        setRadioValues(prevValues => {
            return [...prevValues.filter(item => (item.controlName != controlName)), {controlName: controlName, value: value, showgroup: showgroup, showgroupvalue: showgroupvalue}]
        })

        resetField(controlName, { keepError: false, keepTouched: true, defaultValue: value })
    }

    const getRadioValue = (controlName) => {
        const hasCurrent = radioValues.find(item => (item.controlName === controlName))
        if (hasCurrent) {
            return hasCurrent.value
        }
        else {
            return ''
        }
    }

    const getRadioGroup = (groupName) => {
        if (groupName == undefined) {
            return true
        }
        else {
            const hasCurrent = radioValues.find(item => (item?.showgroup === groupName))
            if (hasCurrent) {
                return (hasCurrent.value === "1" == hasCurrent.showgroupvalue)
            }
            else if (groupName != undefined) {
                return false
            }
            else {
                return true
            }
        }

    }
    const buildDynamicGroupControls = (section, sectionid: number, controlValues: FieldListValues[]) => {
        if (section?.flist && section?.flist?.length > 0) {

            const formControls = section?.flist.sort((a, b) => (a.grp > b.grp ? 1 : -1 && a.ord > b.ord ? 1 : -1)).map((controlData: FieldListObject, controlIndex ) => {
                var control7Values = ''
                var control10Values = ''
                var control10Locked = false
                var control12Values = ''

                const controlName = sectionid.toString() + "--" + controlData.id.toString() + "--" + controlData.ctrl.toString()

                if (controlData.ctrl == 7) {
                    // debugger
                }
                if (controlData.ctrl == 10) {
                    const control10Obj = signatureLocked?.find(sigLockItem => sigLockItem.controlName === controlName)
                    if (control10Obj) {
                        control10Locked = control10Obj.value
                    }
                    const sigObj = getSignatureObject(controlName)
                    if (sigObj && sigObj?.base64Data) {
                        control10Values = sigObj.base64Data
                    }

                    // const dataValuesObject = dlistItem.flist?.find(flistitem => (flistitem.id == controlData.id))
                    // if (dataValuesObject && ('v' + controlData.ctrl) in dataValuesObject) {
                    //     control10Values = dataValuesObject['v' + controlData.ctrl]
                    // }
                    // else {
                    //     console.log('No value for ' + 'v' + controlData.ctrl)
                    //     const dataValuesObject = dlistItem.flist?.find(flistitem => (flistitem.id == controlData.id))
                    //     if (dataValuesObject && ('v' + controlData.ctrl) in dataValuesObject) {
                    //         control12Values = dataValuesObject['v' + controlData.ctrl]
                    //     }
                    // }
                }


                return (
                    <>

                        {controlData.ctrl === 1 &&
                            <Grid item xs={controlData.wd} className={styles.selectcontrol} >
                                <FormControl component="fieldset" fullWidth={true} disabled={controlData.ro || timeEntryData?.isreadonly} required={controlData.req}>
                                    <FormLabel style={{color: controlData?.req && errors[controlName] ? 'red' : 'black'}} id={controlName}>{controlData.lbl}</FormLabel>
                                    <Controller
                                        name={controlName}
                                        control={control}
                                        rules={{ required: controlData.req ? 'Field is required' : false }}
                                        render={({ field , fieldState: { error }}) => (
                                            <RadioGroup
                                                {...field}
                                                value={getRadioValue(controlName)}
                                                onChange={(e) => { handleRadioChange(e, controlName, controlData?.showgroup, controlData?.showgroupvalue)}}
                                                defaultValue={''}
                                                row
                                                aria-labelledby={controlName}
                                                name={controlName}
                                            >
                                                <FormControlLabel key={1} value="1" control={<Radio required={controlData.req}/>} label="Yes" />
                                                <FormControlLabel key={0} value="0" control={<Radio required={controlData.req}/>} label="No" />
                                            </RadioGroup>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        }
                        {controlData.ctrl === 2 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <FormControl required={true} fullWidth={true}>
                                            <Controller
                                                name={controlName}
                                                control={control} // ✅ REQUIRED - uncomment this
                                                rules={{ required: controlData.req ? 'Field is required' : false }}
                                                defaultValue={null}
                                                render={({ field, fieldState: { error } }) => (
                                                    <Autocomplete
                                                        {...field}
                                                        options={getOptions(lookupData, controlData.headerid) || []}
                                                        size="small"
                                                        fullWidth
                                                        getOptionLabel={(option) => option?.label || ''}
                                                        onChange={(event, newValue) => field.onChange(newValue)}
                                                        value={field.value || null} // ✅ Ensure it's null, not undefined
                                                        isOptionEqualToValue={(option, value) =>
                                                            value ? option.value === value.value : false // ✅ Handle null values
                                                        }
                                                        disabled={controlData.ro || timeEntryData?.isreadonly}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={controlData.lbl}
                                                                error={!!error}
                                                                helperText={error?.message}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 3 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Controller
                                            name={controlName} // The name for your form field
                                            control={control}
                                            // defaultValue={0} // Set a default value
                                            rules={{ required: controlData.req ? controlData.lbl + ' is required' : false }}
                                            render={({ field, fieldState: { error } }) => (
                                                <NumberFormat
                                                    {...field} // Pass field props (value, onChange, onBlur)
                                                    customInput={TextField}
                                                    label={controlData.lbl}
                                                    name={controlName}
                                                    size={'small' as any}
                                                    allowNegative={false}
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    defaultValue={""}
                                                    required={controlData.req}
                                                    disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    error={!!error} // Show error state
                                                    helperText={error ? error.message : null}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 4 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Controller
                                            name={controlName} // The name for your form field
                                            // control={control}
                                            // defaultValue={0} // Set a default value
                                            rules={{ required: controlData?.req ? 'Field is required' : false }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field}
                                                    label={controlData.lbl}
                                                    name={controlName}
                                                    fullWidth={true}
                                                    defaultValue={""}
                                                    type={'number'}
                                                    InputProps={{
                                                        inputMode: 'numeric',
                                                        // pattern: '[0-9]*', // Optional: provides a fallback pattern for validation
                                                    }}
                                                    size={'small'}
                                                    required={controlData.req}
                                                    disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    error={!!error} // Show error state
                                                    helperText={error ? error.message : null}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 5 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Controller
                                            name={controlName} // The name for your form field
                                            control={control}
                                            // defaultValue={0} // Set a default value
                                            rules={{ required: controlData?.req ? 'Field is required' : false }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field} // Pass field props (value, onChange, onBlur)
                                                    label={controlData.lbl}
                                                    multiline={controlData.ctrlo > 1}
                                                    rows={controlData.ctrlo > 1 ? controlData.ctrlo : 1}
                                                    name={controlName}
                                                    fullWidth={true}
                                                    defaultValue={""}
                                                    size={'small'}
                                                    required={controlData.req}
                                                    disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    error={!!error} // Show error state
                                                    helperText={error ? error.message : null}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 6 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                                name={controlName}
                                                // control={control}
                                                // defaultValue={0} // Set a default value
                                                rules={{ required: controlData?.req ? 'Field is required' : false }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <DatePicker key={controlName}
                                                                {...field}
                                                                label={controlData.lbl}
                                                                minDate={controlData?.min ? dayjs(controlData.min) : undefined}
                                                                maxDate={controlData?.max ? dayjs(controlData.max) : undefined}
                                                                disableCloseOnSelect={false}
                                                                renderInput={(params) =>
                                                                    <TextField size={'small'}
                                                                               {...field}
                                                                               fullWidth={true}
                                                                               required={controlData.req}
                                                                               {...params}
                                                                               error={!!error} // Show error state
                                                                               helperText={error ? error.message : null}
                                                                               InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                                disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    />

                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 7 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Controller
                                            name={controlName}
                                            control={control}
                                            rules={{ required: controlData?.req ? 'Field is required' : false }}
                                            defaultValue={[]} // Initialize with an empty array for multiple select
                                            render={({ field , fieldState: { error }}) => (
                                                <FormControl fullWidth>
                                                    <InputLabel shrink={true} style={{color: (error ? '#d32f2f' : 'rgba(0,0,0,0.5)')}} id="multiple-select-label">{controlData.lbl}</InputLabel>
                                                    <Select
                                                        {...field}
                                                        notched
                                                        labelId="multiple-select-label"
                                                        id="multiple-select"
                                                        name={controlName}
                                                        multiple
                                                        size={'small'}
                                                        value={field.value}
                                                        onChange={field.onChange}
                                                        label={controlData.lbl}
                                                        required={controlData.req}
                                                        disabled={controlData.ro || timeEntryData?.isreadonly}
                                                        error={!!error}
                                                        // helperText={error ? error.message : null}
                                                    >
                                                        {getOptionsForGroupSelectNew(sectionid, controlData.id, controlData.headerid)}
                                                    </Select>
                                                    {!!error && (
                                                        <FormHelperText style={{color: '#d32f2f'}}>Field is required</FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 8 &&
                            <>
                            {getRadioGroup(controlData?.group) &&
                                <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                    <FormControl fullWidth={true}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                                name={controlName}
                                                // control={control}
                                                // defaultValue={0} // Set a default value
                                                rules={{ required: controlData?.req ? 'Field is required' : false }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <MobileDateTimePicker key={controlName}
                                                                          {...field}
                                                                          label={controlData.lbl}
                                                                          minDate={controlData?.min ? dayjs(controlData.min) : undefined}
                                                                          maxDate={controlData?.max ? dayjs(controlData.max) : undefined}
                                                                          // onAccept={(date) => {handleDateTimeValidation(date, controlData)}}
                                                                          renderInput={(params) =>
                                                                              <TextField size={'small'}
                                                                                         {...field}
                                                                                         fullWidth={true}
                                                                                         required={controlData.req}
                                                                                         {...params}
                                                                                         error={!!error} // Show error state
                                                                                         helperText={error ? error.message : null}
                                                                                         InputLabelProps={{ shrink: true }}
                                                                              />
                                                                          }
                                                                          disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                            }
                            </>
                        }
                        {controlData.ctrl === 9 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Controller
                                            name={controlName}
                                            control={control}
                                            // defaultValue={0} // Set a default value
                                            rules={{ required: controlData?.req ? 'Field is required' : false }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field} // Pass field props (value, onChange, onBlur)
                                                    label={controlData.lbl}
                                                    name={controlName}
                                                    fullWidth={true}
                                                    type="time"
                                                    // defaultValue={""}
                                                    size={'small'}
                                                    required={controlData.req}
                                                    disabled={controlData.ro || timeEntryData?.isreadonly}
                                                    error={!!error} // Show error state
                                                    helperText={error ? error.message : null}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                        {controlData.ctrl === 10 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <>
                                            <Typography variant="body2" gutterBottom>Signature</Typography>
                                            {(control10Values) &&
                                                <img height={'100px'} src={`data:image/png;base64,${control10Values}`}
                                                     alt="Signature" style={{paddingBottom: '20px', maxWidth: '100%'}}/>

                                            }
                                        </>
                                        {timeEntryData?.isreadonly == false &&
                                            <>
                                                {!control10Locked &&
                                                    <Controller
                                                        name={controlName}
                                                        control={control}
                                                        rules={{ required: controlData?.req ? 'Field is required' : false }}
                                                        render={({ field: { onChange, value } }) => (
                                                            <SignatureCanvas
                                                                ref={getNewSignatureRef(controlName)}
                                                                canvasProps={{className: (controlData?.req && errors[controlName] ? styles.sigPadRed : styles.sigPad)}}
                                                                clearOnResize={false}
                                                                onEnd={async () => {
                                                                    const sigReference = getSignatureRef(controlName)
                                                                    const signCanvasFile = dataURLtoFile(sigReference?.current?.getTrimmedCanvas().toDataURL('image/png'), controlName)
                                                                    const fileReader = new FileReader()
                                                                    fileReader.onloadend = function (event) {}
                                                                    fileReader.onload = function (event) {
                                                                        const data = event.target.result as string
                                                                        const dataSpit = data.split(';base64,')[1]
                                                                        setSignatureImageData(controlName, controlData, dataSpit)
                                                                    }

                                                                    new Compressor(signCanvasFile, {
                                                                        quality: 0.4,
                                                                        success(result) {
                                                                            fileReader.readAsDataURL(result)
                                                                        },
                                                                        error(err) {
                                                                            console.log(err.message);
                                                                        },
                                                                    });
                                                                }}
                                                                value={value}
                                                            />
                                                        )}
                                                    />
                                                }
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        gap: 2,
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <button type="button" name={'clear'} className={styles.buttons} onClick={() => {lockUnlockSignaturePad(controlName, !control10Locked)}}>
                                                        {control10Locked ? 'Unlock' : 'Lock'}
                                                    </button>
                                                    {!control10Locked &&
                                                        <button type="button" name={'clear'} className={styles.buttons} onClick={() => {clearSignaturePad(controlName)}}>
                                                            Clear
                                                        </button>
                                                    }
                                                </Box>
                                            </>
                                        }
                                    </Grid>
                                }
                            </>
                        }
                        {/*Photos*/}
                        {controlData.ctrl === 11 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        {getDynamicGroupPhotosSection(sectionid, controlData.id, controlData.lbl)}
                                    </Grid>
                                }
                            </>
                        }
                        {/*Map*/}
                        {(controlData.ctrl === 12 && controlData.ctrlo == 1) &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        {getMap(control12Values)}
                                    </Grid>
                                }
                            </>
                        }
                        {/*Label*/}
                        {controlData.ctrl === 13 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <div style={{width: '100%'}}>
                                            {controlData.lbl}
                                        </div>
                                    </Grid>
                                }
                            </>
                        }
                        {/*Notes*/}
                        {controlData.ctrl === 14 &&
                            <>
                                {getRadioGroup(controlData?.group) &&
                                    <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                        <Grid item xs={controlData.wd} className={styles.selectcontrol}>
                                            <div style={{width: '100%'}}>
                                                <div dangerouslySetInnerHTML={{__html: controlData.lbl}} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                }
                            </>
                        }
                    </>
                )
            })

            return [formControls]
        }
    }

    const doesSectionHaveErrors = (sectionid) => {
        if (errorSections && errorSections?.length > 0) {
            const objFound = errorSections?.find(id => id.startsWith(sectionid))
            if (objFound) {
                return true
            }
        }
        return false
    }

    const handleExpandChange =
        (sectionid: number, defaultState: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            const isFoundObj = expandedState.find(expItem => expItem.sectionid == sectionid)
            if (isFoundObj) {
                if (defaultState == 3) {
                    isFoundObj.expanded = true
                }
                else {
                    setExpandedState(expandedState.filter(expItem => expItem.sectionid != sectionid))
                }
            }
            else {
                const tempExpandedState = [...expandedState]
                setExpandedState([...tempExpandedState, {sectionid: sectionid, expanded: true}])
            }
        }
    const getSectionsAccordion = () => {
        if (
            timeEntryData &&
            timeEntryData?.sections &&
            timeEntryData?.sections.length > 0
        ) {
            return (timeEntryData?.sections).map((section, i) => {
                if (section.sectionname === '*TIME*') {
                    return (
                        // expanded={dispatch.expand}
                        <Accordion disableGutters={true}
                                   onChange={handleExpandChange(section?.sectionid, section?.expand)}
                                   expanded={expandedState.find(expState => expState.sectionid == section?.sectionid) || section?.expand == 3}
                                   defaultExpanded={getExpandedDefault(section?.expand)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography sx={{ color: doesSectionHaveErrors(section?.sectionid) ? 'red' : 'black' }} variant="h6">{section?.sectiontitle ? section?.sectiontitle : 'Dynamic'}</Typography>
                            </AccordionSummary>
                            <AccordionDetails key={section?.sectionid}>
                                <Box>
                                    <HookForm
                                        methods={formMethods}
                                        onSubmit={submitForm}
                                        className={styles.itemsForm}
                                        formProps={{ id: 'time-clock-dynamic-form' }}>
                                        <Grid
                                            key={section?.sectionid}
                                            container
                                            border={0}
                                            direction="row"
                                            xs={12}
                                            spacing={2}
                                        >
                                            {buildDynamicGroupControls(section, section?.sectionid,[])}
                                        </Grid>
                                    </HookForm>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
            })
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        // if (reason === 'clickaway') {
        //     return;
        // }

        setSnackbarOpen({ open: false, message: "", type: 'success' });
    }

    const getMainLabels = () => {
        return (<></>)
        // if (
        //     dispatchData &&
        //     dispatchData.sectiondata &&
        //     dispatchData.sectiondata.length > 0
        // ) {
        //     return (dispatchData?.sectiondata).map((dispatch, i) => {
        //         return (
        //             <>
        //                 <Grid item key={dispatch.value} border={0} xs={8}>
        //                     <Typography variant="body2" gutterBottom>
        //                         {dispatch.label}
        //                     </Typography>
        //                 </Grid>
        //                 <Grid item border={0} xs={4}>
        //                     <Typography variant="body2" gutterBottom>
        //                         {dispatch.value}
        //                     </Typography>
        //                 </Grid>
        //             </>
        //         )
        //     })
        // }
    }

    const closeDialog = () => {
        setDialogMsg("")
        setDialogObj({msg: '', id: null})
    }

    const handleDeleteConfirm = async () => {
        axios.delete(`fieldsystemtimeentry`, {data: {timeentryid: dialogObj.id}}).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            getGridSettings()
            closeDialog()
        })
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Dialog
                    open={dialogObj.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogObj.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={handleDeleteConfirm}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>
            {snackbarOpen.open &&
                <Snackbar
                    open={true}
                    autoHideDuration={4000}
                    onClose={handleClose}
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                >
                    <Alert severity={snackbarOpen.type}>
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            }
            {/*<div hidden={params.displayFileViewer}>*/}
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Container style={{width: '100%'}}>
                        {/*<Box>*/}
                        {/*    <Grid*/}
                        {/*        container*/}
                        {/*        border={0}*/}
                        {/*        direction="row"*/}
                        {/*        alignItems="center"*/}
                        {/*        height={'100%'}*/}
                        {/*        width={'100%'}*/}
                        {/*    >*/}
                        {/*        {getMainLabels()}*/}
                        {/*    </Grid>*/}
                        {/*</Box>*/}
                        <Box>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                height={'100%'}
                                width={'100%'}
                            >
                                <>
                                    <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={12} xs={12}>
                                        <Box>{getSectionsAccordion()}</Box>
                                    </Grid>
                                </>
                            </Grid>
                        </Box>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            paddingBottom: '20px',
                            paddingTop: '20px',
                        }}>
                            <Button variant="contained" className={styles.submitButton} type="submit" form={'time-clock-dynamic-form'}>
                                {timeentryid ? 'Submit Edit' : 'Submit'}
                            </Button>
                            <Button variant="contained"  className={styles.clearButton} onClick={() => {resetForm()}}>
                                {timeentryid ? 'Cancel' : 'Clear'}
                            </Button>
                        </div>
                        {timeEntryGridColumns?.length > 0 &&
                            <DataGridPremium
                                rows={timeEntryGridSetting?.timeentrylist}
                                columns={timeEntryGridColumns}
                                autoHeight={true}
                                density={'compact'}
                                pageSize={25}
                                loading={false}
                                disableMultipleSelection={true}
                                // onRowClick={handleRowClick}
                                // onRowDoubleClick={handleRowClick}
                            />
                        }
                    </Container>


                </div>
            {/*</div>*/}
        </div>
    )
}

export default TimeClockPage